import SuiSql from "./SuiSql.js";


export default SuiSql;